import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Test
   */
  {
    label: "What's your birthday?",
    field: 'birthday',
    type: 'info',
    answer: {
      type: 'date',
      required: true,
      name: 'birthday'
    }
  }
];

export default questionsModels;
